import React from 'react';
import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';

const styles = makeStyles((theme) => ({
    drugContainer: {
        fontFamily: 'mainFont',
        marginBottom: '21px',
        display: 'grid',
        gridTemplateColumns: '3fr 1fr 2fr 3fr',
        '& > div': {
            // display: 'inline-block',
            // marginRight: '13px',
            fontFamily: 'mainFont',
            fontSize: '14px',
            fontWeight: '600',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: '#232733',
            wordWrap: 'break-word'
        },
        [theme.breakpoints.down('1025')]: {
            gridGap: '0',
            '& > div': {
                minWidth: '200px',
                padding: '8px 0',
                borderBottom: 'solid 1.5px #e8ecf2',
                marginRight: '0'
            },
            '& > div:nth-of-type(2)': {
                minWidth: '120px'
            },
            '&:last-child > div': {
                borderBottom: 'none'
            }
        }
    },
    formHeader: {
        color: '#767676',
        marginBottom: '13px',
        display: 'grid',
        gridTemplateColumns: '3fr 1fr 2fr 3fr',
        // gridGap: '10px',
        // background:"red",
        '& > div': {
            // display: 'inline-block',
            // marginRight: '13px',
            fontFamily: 'inherit',
            fontSize: '14px',
            fontWeight: '500',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.5',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: '#545e66'
        },
        [theme.breakpoints.down('1025')]: {
            // gridGap: '0',
            marginTop: '24px',
            '& > div': {
                minWidth: '200px',
                padding: '8px 0',
                borderBottom: 'solid 1.5px #e8ecf2'
            },
            '& > div:nth-of-type(2)': {
                minWidth: '120px'
            }
        }
    }
}));
const DrugView = ({ drugItem }) => {
    const classes = styles({ prop: true });
    if (!drugItem) {
        return null;
    }
    const { drug, drug_form, drug_strength, description } = drugItem;
    return (
        <div className={classes.drugContainer}>
            <div className={classes.name}>{drug?.name}</div>
            <div className={classes.form}>{drug_form?.name}</div>
            <div className={classes.strength}>{drug_strength?.name}</div>
            <div className={classes.description}>{description}</div>
        </div>
    );
};
DrugView.propTypes = {
    drugItem: PropTypes.object
};

export default DrugView;

export const DrugHeader = () => {
    const classes = styles();

    return (
        <div className={classes.formHeader}>
            <div className={classes.name}>Name</div>
            <div className={classes.form}>Form</div>
            <div className={classes.strength}>Strength</div>
            <div className={classes.description}>Description</div>
        </div>
    );
};
